// import { useEffect, useState } from "react";
// import axios from "axios";
// import {
//   FiTrendingUp,
//   FiUsers,
//   FiActivity,
//   FiDollarSign,
//   FiPhone,
//   FiDownload,
//   FiRefreshCw,
//   FiCalendar,
//   FiBarChart2,
//   FiArrowUp,
//   FiArrowDown,
// } from "react-icons/fi";


// import {
//   BarChart,
//   Bar,
//   PieChart,
//   Pie,
//   Cell,
//   XAxis,
//   YAxis,
//   CartesianGrid,
//   Tooltip,
//   ResponsiveContainer,
//   AreaChart,
//   Area,
// } from "recharts";

// const COLORS = ['#FFD700', '#FFA500', '#FF6B6B', '#4ECDC4', '#45B7D1', '#96CEB4'];

// export default function Analytics() {
//   const currentYear = new Date().getFullYear();
//   const currentMonth = new Date().getMonth() + 1;

//   const [year, setYear] = useState(currentYear);
//   const [month, setMonth] = useState(currentMonth);
//   const [selectedDate, setSelectedDate] = useState(new Date().toISOString().split('T')[0]);
//   const [startDate, setStartDate] = useState(() => {
//     const d = new Date();
//     d.setDate(d.getDate() - 7);
//     return d.toISOString().split('T')[0];
//   });
//   const [endDate, setEndDate] = useState(new Date().toISOString().split('T')[0]);
//   const [timeRange, setTimeRange] = useState("monthly"); // daily, weekly, monthly, yearly
//   const [activeTab, setActiveTab] = useState("overview"); // overview, users, revenue, calls, engagement
//   const [loading, setLoading] = useState(true);
//   const [autoRefresh, setAutoRefresh] = useState(false);

//   const [analytics, setAnalytics] = useState({
//     // Overview stats
//     totalUsers: 0,
//     activeUsers: 0,
//     newUsers: 0,
//     totalRevenue: 0,
//     totalWithdrawn: 0,
//     totalCalls: 0,
//     totalGifts: 0,


//      totalUsers: 0,
//   femaleUsers: 0, 

//     // Trends
//     userGrowth: [],
//     revenueGrowth: [],
//     callGrowth: [],

//     // Gender distribution
//     genderDistribution: { male: 0, female: 0 },

//     // Call statistics
//     audioCalls: 0,
//     videoCalls: 0,
//     avgCallDuration: 0,

//     // Engagement
//     avgSessionDuration: 0,
//     dailyActiveUsers: 0,
//     weeklyActiveUsers: 0,

//     // Revenue breakdown
//     revenueBySource: [],

//     // Time-based data
//     dailyStats: [],
//     weeklyStats: [],
//     monthlyStats: [],
//   });

//   useEffect(() => {
//     fetchAnalytics();

//     if (autoRefresh) {
//       const interval = setInterval(fetchAnalytics, 30000); // Refresh every 30 seconds
//       return () => clearInterval(interval);
//     }
//   }, [year, month, selectedDate, startDate, endDate, timeRange, autoRefresh]);


//   const fetchAnalytics = async () => {
//     try {

//       setLoading(true);

//       // ✅ CLEAR OLD CHART DATA HERE
//       setAnalytics(prev => ({
//         ...prev,
//         monthlyStats: []
//       }));
//       const params = {
//         timeRange,
//         year,
//         month,
//         date: selectedDate,
//         startDate,
//         endDate
//       };



//       const [
//         dashboardRes,
       
//         activityRes,

//         // NEW REVENUE APIs
//         revenueOverviewRes,
//         revenueTrendRes,
      

//         // ✅ CALL APIs
//         callOverviewRes,
//         callTrendRes,
        
//        usersSummaryRes,
//        userGrowthRes




//       ] = await Promise.all([
//         axios.get("/api/v1/admin/analytics/dashboard", { params }),
//         axios.get("/api/v1/app/user-activity/summary", { params }).catch(() => ({ data: { status: "ERROR" } })),

//         // ✅ NEW
//         axios.get("/api/v2/admin/revenue/revenue-overview", { params }),
//         axios.get("/api/v2/admin/revenue/revenue-trend", { params }),


//         // ✅ NEW CALL APIs
//         axios.get("/api/v2/admin/callAnalytics/overview", { params }),
//         axios.get("/api/v2/admin/callAnalytics/trend", { params }),
//        axios.get("/api/v2/admin/users/summary",{params}),
//        axios.get("/api/v2/admin/users/growth",{params}),
//       ]);




//       // Dashboard stats
//       if (dashboardRes.data.success) {
//         const data = dashboardRes.data.data;
//         setAnalytics((prev) => ({
//           ...prev,
         
//           activeUsers: data.activeUsers || 0,
//           newUsers: data.newUsersThisMonth || 0,
//         }));
//       }

//       // Activity stats
//       if (activityRes.data.status === "OK") {
//         const activity = activityRes.data.data || {};
//         setAnalytics((prev) => ({
//           ...prev,
//           audioCalls: activity.audioCalls || 0,
//           videoCalls: activity.videoCalls || 0,
//           totalCalls: (activity.audioCalls || 0) + (activity.videoCalls || 0),

//         }));
//       }



//       // ✅ Revenue Overview
//       if (revenueOverviewRes.data.success) {
//         const r = revenueOverviewRes.data.data;

//         setAnalytics(prev => ({
//           ...prev,
//           totalRevenue: r.totalRevenue || 0,
//           totalWithdrawn: r.totalWithdrawn || 0,
//         }));
//       }



//       if (revenueTrendRes.data.success) {
//         const raw = revenueTrendRes.data.data || [];

//         const formatted = raw.map(item => {
//           let label = "";

//           if (timeRange === "yearly") {
//             label = new Date(year, item.month - 1)
//               .toLocaleString("en-US", { month: "short" });
//           }
//           else if (timeRange === "monthly") {
//             label = `Day ${item.day}`;
//           }
//           else {
//             label = new Date(item.date)
//               .toLocaleDateString("en-IN");
//           }

//           return {
//             month: label,
//             revenue: Number(item.revenue || 0)
//           };
//         });

//         setAnalytics(prev => ({
//           ...prev,
//           monthlyStats: formatted
//         }));
//       }



//       // ✅ CALL OVERVIEW
//       if (callOverviewRes.data.success) {
//         const c = callOverviewRes.data.data;

//         setAnalytics(prev => ({
//           ...prev,
//           totalCalls: c.totalCalls || 0,
//           audioCalls: c.audioCalls || 0,
//           videoCalls: c.videoCalls || 0,
//           avgCallDuration: c.avgDuration || 0
//         }));
//       }





//       if (callTrendRes.data.success) {
//         const formatted = callTrendRes.data.data.map(item => ({
//           month:
//             item.month
//               ? new Date(year, item.month - 1)
//                 .toLocaleString("en-US", { month: "short" })
//               : item.day
//                 ? `Day ${item.day}`
//                 : new Date(item.date)
//                   .toLocaleDateString("en-IN"),
//           calls: item.calls
//         }));

//         setAnalytics(prev => ({
//           ...prev,
//           callGrowth: formatted
//         }));
//       }



//       if(usersSummaryRes.data.success){
//   const u = usersSummaryRes.data.data;


//   const totalUsers = u.newUsers || 0;
//   const femaleUsers = u.newfemaleUsers || 0;
//   const maleUsers = u.newUsers - u.newfemaleUsers;

//   setAnalytics(prev=>({
//     ...prev,


//     // ✅ Overview values (time-range based)
//     totalUsers: totalUsers,
//     femaleUsers: femaleUsers,

//     total:u.total,
//     newUsers:u.newUsers,
//     newfemaleUsers:u.newfemaleUsers,



// genderDistribution: {
//       male: maleUsers,
//       female: femaleUsers
//     }




    
//   }));
// }


// if(userGrowthRes.data.success){

//   const normalized = userGrowthRes.data.data.map(item=>{

//     let month = "";

//     if(item.month) month = item.month;
//     else if(item.day) month = item.day;
//     else if(item.date) month = item.date;
//     else if(item.hour !== undefined) month = item.hour;

//     return {
//       month,
//       count:item.count || 0
//     };
//   });

//   setAnalytics(prev=>({
//     ...prev,
//     userGrowth:normalized
//   }));
// }


      
      


//     } catch (error) {
//       console.error("Error fetching analytics:", error);
//     } finally {
//       setLoading(false);
//     }
//   };


//   const formatCurrency = (amount) => {
//     return `₹${(amount || 0).toLocaleString("en-IN")}`;
//   };

//   const formatNumber = (num) => {
//     return (num || 0).toLocaleString("en-IN");
//   };



//   if (loading && !analytics.totalUsers) {
//     return (
//       <div className="p-6 bg-[var(--black)] min-h-screen flex items-center justify-center">
//         <div className="w-10 h-10 rounded-full animate-spin border-4 border-[color:var(--yellow)/0.25] border-t-[var(--yellow)]" />
//       </div>
//     );
//   }

//   const genderData = [
//     { name: "Male", value: analytics.genderDistribution.male },
//     { name: "Female", value: analytics.genderDistribution.female },
//   ];

//   const revenueData = analytics.monthlyStats || [];

//   return (
//     <div className="p-6 space-y-6 bg-[var(--black)] min-h-screen text-[var(--yellow)]">
//       {/* Header */}
//       <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4 mb-6">
//         <div className="flex items-center gap-3">
//           <FiTrendingUp className="text-3xl" />
//           <div>
//             <h1 className="text-3xl font-bold">Advanced Analytics</h1>
//             <p className="text-sm opacity-80">Comprehensive insights and metrics</p>
//           </div>
//         </div>

//         <div className="flex items-center gap-3">
//           <button
//             onClick={() => setAutoRefresh(!autoRefresh)}
//             className={`px-4 py-2 rounded-lg border-2 border-gray-300 flex items-center gap-2 transition ${autoRefresh
//               ? "bg-[var(--yellow)] text-[var(--black)]"
//               : "bg-[var(--black)] text-[var(--yellow)]"
//               }`}
//           >
//             <FiRefreshCw className={autoRefresh ? "animate-spin" : ""} />
//             Auto Refresh
//           </button>

//           <button
//             onClick={fetchAnalytics}
//             className="px-4 py-2 rounded-lg border-2 border-gray-300 bg-[var(--black)] text-[var(--yellow)] flex items-center gap-2 hover:bg-[var(--yellow)] hover:text-[var(--black)] transition"
//           >
//             <FiRefreshCw />
//             Refresh
//           </button>

//           <button
//             onClick={() => {
//               // Export functionality
//               const dataStr = JSON.stringify(analytics, null, 2);
//               const dataBlob = new Blob([dataStr], { type: "application/json" });
//               const url = URL.createObjectURL(dataBlob);
//               const link = document.createElement("a");
//               link.href = url;
//               link.download = `analytics-${new Date().toISOString().split("T")[0]}.json`;
//               link.click();
//             }}
//             className="px-4 py-2 rounded-lg border-2 border-gray-300 bg-[var(--black)] text-[var(--yellow)] flex items-center gap-2 hover:bg-[var(--yellow)] hover:text-[var(--black)] transition"
//           >
//             <FiDownload />
//             Export
//           </button>
//         </div>
//       </div>

//       {/* Filters */}
//       <div className="flex flex-wrap items-center gap-4 p-4 bg-[var(--black)] border-2 border-gray-300 rounded-xl">
//         <div className="flex items-center gap-2">
//           <FiCalendar />
//           <span className="font-medium">Time Range:</span>
//           <select
//             value={timeRange}
//             onChange={(e) => setTimeRange(e.target.value)}
//             className="bg-[var(--black)] border-2 border-gray-300 px-3 py-2 rounded text-[var(--yellow)]"
//           >
//             <option value="daily">Daily</option>
//             <option value="weekly">Weekly</option>
//             <option value="monthly">Monthly</option>
//             <option value="yearly">Yearly</option>
//           </select>
//         </div>

//         {timeRange === "daily" && (
//           <div className="flex items-center gap-2">
//             <span className="text-sm font-medium">Select Date:</span>
//             <input
//               type="date"
//               value={selectedDate}
//               onChange={(e) => setSelectedDate(e.target.value)}
//               className="bg-[var(--black)] border-2 border-gray-300 px-3 py-2 rounded text-[var(--yellow)] focus:outline-none focus:ring-2 focus:ring-[color:var(--yellow)/0.6]"
//             />
//           </div>
//         )}

//         {timeRange === "weekly" && (
//           <div className="flex flex-wrap items-center gap-4">
//             <div className="flex items-center gap-2">
//               <span className="text-sm font-medium text-[color:var(--yellow)/0.8]">From:</span>
//               <input
//                 type="date"
//                 value={startDate}
//                 onChange={(e) => setStartDate(e.target.value)}
//                 className="bg-[var(--black)] border-2 border-gray-300 px-3 py-2 rounded text-[var(--yellow)] focus:outline-none focus:ring-2 focus:ring-[color:var(--yellow)/0.6]"
//               />
//             </div>
//             <div className="flex items-center gap-2">
//               <span className="text-sm font-medium text-[color:var(--yellow)/0.8]">To:</span>
//               <input
//                 type="date"
//                 value={endDate}
//                 onChange={(e) => setEndDate(e.target.value)}
//                 className="bg-[var(--black)] border-2 border-gray-300 px-3 py-2 rounded text-[var(--yellow)] focus:outline-none focus:ring-2 focus:ring-[color:var(--yellow)/0.6]"
//               />
//             </div>
//           </div>
//         )}

//         {timeRange === "yearly" && (
//           <select
//             value={year}
//             onChange={(e) => setYear(Number(e.target.value))}
//             className="bg-[var(--black)] border-2 border-gray-300 px-3 py-2 rounded text-[var(--yellow)]"
//           >
//             {[currentYear, currentYear - 1, currentYear - 2].map((y) => (
//               <option key={y} value={y}>
//                 {y}
//               </option>
//             ))}
//           </select>
//         )}

//         {timeRange === "monthly" && (
//           <>
//             <select
//               value={year}
//               onChange={(e) => setYear(Number(e.target.value))}
//               className="bg-[var(--black)] border-2 border-gray-300 px-3 py-2 rounded text-[var(--yellow)]"
//             >
//               {[currentYear, currentYear - 1, currentYear - 2].map((y) => (
//                 <option key={y} value={y}>
//                   {y}
//                 </option>
//               ))}
//             </select>
//             <select
//               value={month}
//               onChange={(e) => setMonth(Number(e.target.value))}
//               className="bg-[var(--black)] border-2 border-gray-300 px-3 py-2 rounded text-[var(--yellow)]"
//             >
//               {Array.from({ length: 12 }, (_, i) => i + 1).map((m) => (
//                 <option key={m} value={m}>
//                   {new Date(year, m - 1).toLocaleString("en-US", { month: "long" })}
//                 </option>
//               ))}
//             </select>
//           </>
//         )}
//       </div>

//       {/* Tabs */}
//       <div className="flex flex-wrap gap-2 border-b-2 border-gray-300">
//         {[
//           { id: "overview", label: "Overview", icon: <FiBarChart2 /> },
//           { id: "users", label: "Users", icon: <FiUsers /> },
//           { id: "revenue", label: "Revenue", icon: <FiDollarSign /> },
//           { id: "calls", label: "Calls", icon: <FiPhone /> },
          
//         ].map((tab) => (
//           <button
//             key={tab.id}
//             onClick={() => setActiveTab(tab.id)}
//             className={`px-6 py-3 font-medium flex items-center gap-2 transition ${activeTab === tab.id
//               ? "border-b-4 border-gray-300 text-[var(--yellow)]"
//               : "text-[color:var(--yellow)/0.6] hover:text-[var(--yellow)]"
//               }`}
//           >
//             {tab.icon}
//             {tab.label}
//           </button>
//         ))}
//       </div>

//       {/* Overview Tab */}
//       {activeTab === "overview" && (
//         <div className="space-y-6">
//           {/* Key Metrics */}
//           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6">
//             <MetricCard
//               title="Total Users"
//               value={formatNumber(analytics.totalUsers)}
//               icon={<FiUsers />}

//               color="yellow"
//             />
//             <MetricCard
//               title="female Users"
//               value={formatNumber(analytics.femaleUsers)}
//               icon={<FiActivity />}
//               color="green"
//             />
//             <MetricCard
//               title="Total Revenue"
//               value={formatCurrency(analytics.totalRevenue)}
//               icon={<FiTrendingUp />}

//               color="blue"
//             />
//             <MetricCard
//               title="Total Withdrawals"
//               value={formatCurrency(analytics.totalWithdrawn)}
//               icon={<FiDownload />}
//               color="purple"
//             />
//             <MetricCard
//               title="Total Calls"
//               value={formatNumber(analytics.totalCalls)}
//               icon={<FiPhone />}
//               color="orange"
//             />
//           </div>

//           {/* Charts Row 1 */}
//           <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
//             <ChartCard title="User Growth Trend">
//               <UserGrowthChart data={analytics.userGrowth} year={year} />
//             </ChartCard>

//             <ChartCard title="Gender Distribution">
//               <ResponsiveContainer width="100%" height={300}>
//                 <PieChart>
//                   <Pie
//                     data={genderData}
//                     cx="50%"
//                     cy="50%"
//                     labelLine={false}
//                     label={({ name, percent }) => `${name} ${(percent * 100).toFixed(0)}%`}
//                     outerRadius={100}
//                     fill="#8884d8"
//                     dataKey="value"
//                   >
//                     {genderData.map((entry, index) => (
//                       <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
//                     ))}
//                   </Pie>
//                   <Tooltip />
//                 </PieChart>
//               </ResponsiveContainer>
//             </ChartCard>
//           </div>

//           {/* Charts Row 2 */}
//           <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
//             <ChartCard title="Revenue Trend">
//               <ResponsiveContainer width="100%" height={300}>
//                 <AreaChart data={revenueData}>
//                   <CartesianGrid strokeDasharray="3 3" stroke="rgba(255, 215, 0, 0.1)" />
//                   <XAxis dataKey="month" stroke="var(--yellow)" />
//                   <YAxis stroke="var(--yellow)" />
//                   <Tooltip
//                     contentStyle={{
//                       backgroundColor: "var(--black)",
//                       border: "2px solid var(--yellow)",
//                       borderRadius: "8px",
//                       color: "var(--yellow)",
//                     }}
//                   />
//                   <Area
//                     type="monotone"
//                     dataKey="revenue"
//                     stroke="var(--yellow)"
//                     fill="var(--yellow)"
//                     fillOpacity={0.3}
//                   />
//                 </AreaChart>
//               </ResponsiveContainer>
//             </ChartCard>

//             <ChartCard title="Call Statistics">
//               <div className="space-y-4">
//                 <div className="flex justify-between items-center p-4 border border-gray-300 rounded-lg">
//                   <span>Audio Calls</span>
//                   <span className="text-2xl font-bold">{formatNumber(analytics.audioCalls)}</span>
//                 </div>
//                 <div className="flex justify-between items-center p-4 border border-gray-300 rounded-lg">
//                   <span>Video Calls</span>
//                   <span className="text-2xl font-bold">{formatNumber(analytics.videoCalls)}</span>
//                 </div>
//                 <div className="flex justify-between items-center p-4 border border-gray-300 rounded-lg">
//                   <span>Total Calls</span>
//                   <span className="text-2xl font-bold">{formatNumber(analytics.totalCalls)}</span>
//                 </div>
//               </div>
//             </ChartCard>
//           </div>
//         </div>
//       )}

//       {/* Users Tab */}
//       {activeTab === "users" && (
//         <div className="space-y-6">
//           <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
//             <MetricCard
//               title="total Users"
//               value={formatNumber(analytics.total)}
//               icon={<FiUsers />}
//               color="blue"
//             />
//             <MetricCard
//               title="New Users"
//               value={formatNumber(analytics?.newUsers)}
//               icon={<FiActivity />}
//               color="green"
//             />
//             <MetricCard
//               title="New Female Users"
//               value={formatNumber(analytics?.newfemaleUsers || 0)}
//               icon={<FiActivity />}
//               color="purple"
//             />
//           </div>

//           <ChartCard title="Monthly User Growth">
//             <UserGrowthChart data={analytics.userGrowth} year={year} />
//           </ChartCard>
//         </div>
//       )}

//       {/* Revenue Tab */}
//       {activeTab === "revenue" && (
//         <div className="space-y-6">
//           <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
//             <MetricCard
//               title="Total Revenue"
//               value={formatCurrency(analytics.totalRevenue)}
//               icon={<FiTrendingUp />}
//               color="blue"
//             />
//             <MetricCard
//               title="Total Withdrawals"
//               value={formatCurrency(analytics.totalWithdrawn)}
//               icon={<FiDownload />}
//               color="purple"
//             />
//           </div>

//           <ChartCard title="Revenue Trend">
//             <ResponsiveContainer width="100%" height={400}>

//               {revenueData.length === 0 ? (
//                 <div className="text-center py-10">No data</div>
//               ) : (
//                 <BarChart key={`${timeRange}-${year}-${month}-${selectedDate}-${startDate}-${endDate}`} data={revenueData}>
//                   <CartesianGrid strokeDasharray="3 3" stroke="rgba(255, 215, 0, 0.1)" />
//                   <XAxis dataKey="month" stroke="var(--yellow)" />
//                   <YAxis stroke="var(--yellow)" />
//                   <Tooltip
//                     contentStyle={{
//                       backgroundColor: "var(--black)",
//                       border: "2px solid var(--yellow)",
//                       borderRadius: "8px",
//                       color: "var(--yellow)",
//                     }}
//                     formatter={(value) => formatCurrency(value)}
//                   />
//                   <Bar dataKey="revenue" fill="var(--yellow)" radius={[8, 8, 0, 0]} />
//                 </BarChart>
//               )}


//             </ResponsiveContainer>
//           </ChartCard>
//         </div>
//       )}

//       {/* Calls Tab */}
//       {activeTab === "calls" && (
//         <div className="space-y-6">
//           <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
//             <MetricCard
//               title="Audio Calls"
//               value={formatNumber(analytics.audioCalls)}
//               icon={<FiPhone />}
//               color="green"
//             />
//             <MetricCard
//               title="Video Calls"
//               value={formatNumber(analytics.videoCalls)}
//               icon={<FiPhone />}
//               color="blue"
//             />
//             <MetricCard
//               title="Total Calls"
//               value={formatNumber(analytics.totalCalls)}
//               icon={<FiPhone />}
//               color="purple"
//             />
//           </div>

//           <ChartCard title="Call Type Distribution">
//             <ResponsiveContainer width="100%" height={300}>
//               <PieChart>
//                 <Pie
//                   data={[
//                     { name: "Audio", value: analytics.audioCalls },
//                     { name: "Video", value: analytics.videoCalls },
//                   ]}
//                   cx="50%"
//                   cy="50%"
//                   labelLine={false}
//                   label={({ name, percent }) => `${name} ${(percent * 100).toFixed(0)}%`}
//                   outerRadius={100}
//                   fill="#8884d8"
//                   dataKey="value"
//                 >
//                   <Cell fill="#FFD700" />
//                   <Cell fill="#FFA500" />
//                 </Pie>
//                 <Tooltip />
//               </PieChart>
//             </ResponsiveContainer>
//           </ChartCard>
//         </div>
//       )}
//     </div>
//   );
// }

// // Metric Card Component
// function MetricCard({ title, value, icon, change, trend, size = "normal", color = "yellow" }) {
//   const colorClasses = {
//     yellow: {
//       bg: "bg-gradient-to-br from-[var(--yellow)]/10 to-[var(--yellow)]/5 border-[var(--yellow)]/20",
//       text: "text-[var(--yellow)]",
//       icon: "text-[var(--yellow)]"
//     },
//     green: {
//       bg: "bg-gradient-to-br from-green-500/10 to-green-500/5 border-green-500/20",
//       text: "text-green-400",
//       icon: "text-green-400"
//     },
//     blue: {
//       bg: "bg-gradient-to-br from-blue-500/10 to-blue-500/5 border-blue-500/20",
//       text: "text-blue-400",
//       icon: "text-blue-400"
//     },
//     purple: {
//       bg: "bg-gradient-to-br from-purple-500/10 to-purple-500/5 border-purple-500/20",
//       text: "text-purple-400",
//       icon: "text-purple-400"
//     },
//     orange: {
//       bg: "bg-gradient-to-br from-orange-500/10 to-orange-500/5 border-orange-500/20",
//       text: "text-orange-400",
//       icon: "text-orange-400"
//     }
//   };

//   return (
//     <div className={`${colorClasses[color].bg} border-2 rounded-xl p-3 shadow-lg ${size === "large" ? "col-span-full" : ""
//       }`}>
//       <div className="flex items-center justify-between">
//         <div className="flex-1">
//           <div className={`text-xs font-medium ${colorClasses[color].text} mb-1 uppercase tracking-wider`}>
//             {title}
//           </div>
//           <div className={`font-bold ${size === "large" ? "text-4xl" : "text-2xl"} ${colorClasses[color].text}`}>
//             {value}
//           </div>

//           {change && (
//             <div className={`flex items-center gap-1 mt-1 text-xs ${trend === "up" ? "text-green-400" : "text-red-400"
//               }`}>
//               {trend === "up" ? <FiArrowUp /> : <FiArrowDown />}
//               {change}
//             </div>
//           )}
//         </div>
//         <div className={`text-3xl ${colorClasses[color].icon}`}>{icon}</div>
//       </div>
//     </div>
//   );
// }

// // Chart Card Component
// function ChartCard({ title, children }) {
//   return (
//     <div className="rounded-lg p-6 border-2 border-gray-300 bg-[var(--black)] shadow-sm">
//       <h3 className="text-xl font-bold mb-4">{title}</h3>
//       {children}
//     </div>
//   );
// }

// // User Growth Chart Component
// function UserGrowthChart({ data, year }) {
//   const maxGrowth = data.length > 0 ? Math.max(...data.map((i) => i.count || 0)) : 1;

//   if (!data || data.length === 0) {
//     return (
//       <div className="h-64 flex items-center justify-center text-[color:var(--yellow)/0.8] border-2 border-dashed border-[color:var(--yellow)/0.06] rounded">
//         No growth data available
//       </div>
//     );
//   }

//   return (
//     <ResponsiveContainer width="100%" height={300}>
//       <BarChart data={data.map((item) => ({
//         month:
//   typeof item.month === "number"
//     ? new Date(year, item.month - 1)
//         .toLocaleString("en-US",{month:"short"})
//     : item.month,

//         count: item.count || 0,
//       }))}>
//         <CartesianGrid strokeDasharray="3 3" stroke="rgba(255, 215, 0, 0.1)" />
//         <XAxis dataKey="month" stroke="var(--yellow)" />
//         <YAxis stroke="var(--yellow)" />
//         <Tooltip
//           contentStyle={{
//             backgroundColor: "var(--black)",
//             border: "2px solid var(--yellow)",
//             borderRadius: "8px",
//             color: "var(--yellow)",
//           }}
//         />
//         <Bar dataKey="count" fill="var(--yellow)" radius={[8, 8, 0, 0]} />
//       </BarChart>
//     </ResponsiveContainer>
//   );
// }















import { useEffect, useState } from "react";
import axios from "axios";
import {
  FiTrendingUp,
  FiUsers,
  FiActivity,
  FiDollarSign,
  FiPhone,
  FiDownload,
  FiRefreshCw,
  FiCalendar,
  FiBarChart2,
  FiArrowUp,
  FiArrowDown,
} from "react-icons/fi";


import {
  BarChart,
  Bar,
  PieChart,
  Pie,
  Cell,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  AreaChart,
  Area,
} from "recharts";

const COLORS = ['#FFD700', '#FFA500', '#FF6B6B', '#4ECDC4', '#45B7D1', '#96CEB4'];

export default function Analytics() {
  const currentYear = new Date().getFullYear();
  const currentMonth = new Date().getMonth() + 1;

  const [year, setYear] = useState(currentYear);
  const [month, setMonth] = useState(currentMonth);
  const [selectedDate, setSelectedDate] = useState(new Date().toISOString().split('T')[0]);
  const [startDate, setStartDate] = useState(() => {
    const d = new Date();
    d.setDate(d.getDate() - 7);
    return d.toISOString().split('T')[0];
  });
  const [endDate, setEndDate] = useState(new Date().toISOString().split('T')[0]);
  const [timeRange, setTimeRange] = useState("monthly"); // daily, weekly, monthly, yearly
  const [activeTab, setActiveTab] = useState("overview"); // overview, users, revenue, calls, engagement
  const [loading, setLoading] = useState(true);
  const [autoRefresh, setAutoRefresh] = useState(false);

  const [analytics, setAnalytics] = useState({
    // Overview stats
    totalUsers: 0,
    activeUsers: 0,
    newUsers: 0,
    totalRevenue: 0,
    totalWithdrawn: 0,
    totalCalls: 0,
    totalGifts: 0,


     totalUsers: 0,
  femaleUsers: 0, 

    // ✅ NEW
    violationsTrend: [],
    blockTrend: [],

    // Trends
    userGrowth: [],
    revenueGrowth: [],
    callGrowth: [],

    // Gender distribution
    genderDistribution: { male: 0, female: 0 },

    // Call statistics
    audioCalls: 0,
    videoCalls: 0,
    avgCallDuration: 0,

    // Engagement
    avgSessionDuration: 0,
    dailyActiveUsers: 0,
    weeklyActiveUsers: 0,

    // Revenue breakdown
    revenueBySource: [],

    // Time-based data
    dailyStats: [],
    weeklyStats: [],
    monthlyStats: [],
  });

  useEffect(() => {
    fetchAnalytics();

    if (autoRefresh) {
      const interval = setInterval(fetchAnalytics, 30000); // Refresh every 30 seconds
      return () => clearInterval(interval);
    }
  }, [year, month, selectedDate, startDate, endDate, timeRange, autoRefresh]);


  const fetchAnalytics = async () => {
    try {

      setLoading(true);

      // ✅ CLEAR OLD CHART DATA HERE
      setAnalytics(prev => ({
        ...prev,
        monthlyStats: []
      }));
      const params = {
        timeRange,
        year,
        month,
        date: selectedDate,
        startDate,
        endDate
      };



      const [
        dashboardRes,
       
        activityRes,

        // NEW REVENUE APIs
        revenueOverviewRes,
        revenueTrendRes,
      

        // ✅ CALL APIs
        callOverviewRes,
        callTrendRes,
        
       usersSummaryRes,
       userGrowthRes,


         violationsTrendRes,
        blockTrendRes,


      ] = await Promise.all([
        axios.get("/api/v1/admin/analytics/dashboard", { params }),
        axios.get("/api/v1/app/user-activity/summary", { params }).catch(() => ({ data: { status: "ERROR" } })),

        // ✅ NEW
        axios.get("/api/v2/admin/revenue/revenue-overview", { params }),
        axios.get("/api/v2/admin/revenue/revenue-trend", { params }),


        // ✅ NEW CALL APIs
        axios.get("/api/v2/admin/callAnalytics/overview", { params }),
        axios.get("/api/v2/admin/callAnalytics/trend", { params }),
       axios.get("/api/v2/admin/users/summary",{params}),
       axios.get("/api/v2/admin/users/growth",{params}),

         axios.get("/api/v1/admin/voliation/report-trend", { params }),
        axios.get("/api/v1/admin/voliation/block-trend", { params }),
      ]);




      // Dashboard stats
      if (dashboardRes.data.success) {
        const data = dashboardRes.data.data;
        setAnalytics((prev) => ({
          ...prev,
         
          activeUsers: data.activeUsers || 0,
          newUsers: data.newUsersThisMonth || 0,
        }));
      }

      // Activity stats
      if (activityRes.data.status === "OK") {
        const activity = activityRes.data.data || {};
        setAnalytics((prev) => ({
          ...prev,
          audioCalls: activity.audioCalls || 0,
          videoCalls: activity.videoCalls || 0,
          totalCalls: (activity.audioCalls || 0) + (activity.videoCalls || 0),

        }));
      }



      // ✅ Revenue Overview
      if (revenueOverviewRes.data.success) {
        const r = revenueOverviewRes.data.data;

        setAnalytics(prev => ({
          ...prev,
          totalRevenue: r.totalRevenue || 0,
          totalWithdrawn: r.totalWithdrawn || 0,
        }));
      }



      if (revenueTrendRes.data.success) {
        const raw = revenueTrendRes.data.data || [];

        const formatted = raw.map(item => {
          let label = "";

          if (timeRange === "yearly") {
            label = new Date(year, item.month - 1)
              .toLocaleString("en-US", { month: "short" });
          }
          else if (timeRange === "monthly") {
            label = `Day ${item.day}`;
          }
          else {
            label = new Date(item.date)
              .toLocaleDateString("en-IN");
          }

          return {
            month: label,
            revenue: Number(item.revenue || 0)
          };
        });

        setAnalytics(prev => ({
          ...prev,
          monthlyStats: formatted
        }));
      }



      // ✅ CALL OVERVIEW
      if (callOverviewRes.data.success) {
        const c = callOverviewRes.data.data;

        setAnalytics(prev => ({
          ...prev,
          totalCalls: c.totalCalls || 0,
          audioCalls: c.audioCalls || 0,
          videoCalls: c.videoCalls || 0,
          avgCallDuration: c.avgDuration || 0
        }));
      }





      if (callTrendRes.data.success) {
        const formatted = callTrendRes.data.data.map(item => ({
          month:
            item.month
              ? new Date(year, item.month - 1)
                .toLocaleString("en-US", { month: "short" })
              : item.day
                ? `Day ${item.day}`
                : new Date(item.date)
                  .toLocaleDateString("en-IN"),
          calls: item.calls
        }));

        setAnalytics(prev => ({
          ...prev,
          callGrowth: formatted
        }));
      }



      if(usersSummaryRes.data.success){
  const u = usersSummaryRes.data.data;


  const totalUsers = u.newUsers || 0;
  const femaleUsers = u.newfemaleUsers || 0;
  const maleUsers = u.newUsers - u.newfemaleUsers;

  setAnalytics(prev=>({
    ...prev,


    // ✅ Overview values (time-range based)
    totalUsers: totalUsers,
    femaleUsers: femaleUsers,

    total:u.total,
    newUsers:u.newUsers,
    newfemaleUsers:u.newfemaleUsers,



genderDistribution: {
      male: maleUsers,
      female: femaleUsers
    }




    
  }));
}


if(userGrowthRes.data.success){

  const normalized = userGrowthRes.data.data.map(item=>{

    let month = "";

    if(item.month) month = item.month;
    else if(item.day) month = item.day;
    else if(item.date) month = item.date;
    else if(item.hour !== undefined) month = item.hour;

    return {
      month,
      count:item.count || 0
    };
  });

  setAnalytics(prev=>({
    ...prev,
    userGrowth:normalized
  }));
}



      // ✅ Violations Trend
      if (violationsTrendRes.data.success) {
        const formatted = violationsTrendRes.data.data.map(item => ({
          month: item.month
            ? new Date(year, item.month - 1).toLocaleString("en-US", { month: "short" })
            : item.day
              ? `Day ${item.day}`
              : new Date(item.date).toLocaleDateString("en-IN"),
          reports: item.totalReports || 0
        }));

        setAnalytics(prev => ({ ...prev, violationsTrend: formatted }));
      }

      // ✅ Block Trend
      if (blockTrendRes.data.success) {
        const formatted = blockTrendRes.data.data.map(item => ({
          month: item.month
            ? new Date(year, item.month - 1).toLocaleString("en-US", { month: "short" })
            : item.day
              ? `Day ${item.day}`
              : new Date(item.date).toLocaleDateString("en-IN"),
          blocks: item.totalBlocks || 0
        }));

        setAnalytics(prev => ({ ...prev, blockTrend: formatted }));
      }

      
      


    } catch (error) {
      console.error("Error fetching analytics:", error);
    } finally {
      setLoading(false);
    }
  };


  const formatCurrency = (amount) => {
    return `₹${(amount || 0).toLocaleString("en-IN")}`;
  };

  const formatNumber = (num) => {
    return (num || 0).toLocaleString("en-IN");
  };



  if (loading && !analytics.totalUsers) {
    return (
      <div className="p-6 bg-[var(--black)] min-h-screen flex items-center justify-center">
        <div className="w-10 h-10 rounded-full animate-spin border-4 border-[color:var(--yellow)/0.25] border-t-[var(--yellow)]" />
      </div>
    );
  }

  const genderData = [
    { name: "Male", value: analytics.genderDistribution.male },
    { name: "Female", value: analytics.genderDistribution.female },
  ];

  const revenueData = analytics.monthlyStats || [];

  return (
    <div className="p-6 space-y-6 bg-[var(--black)] min-h-screen text-[var(--yellow)]">
      {/* Header */}
      <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4 mb-6">
        <div className="flex items-center gap-3">
          <FiTrendingUp className="text-3xl" />
          <div>
            <h1 className="text-3xl font-bold">Advanced Analytics</h1>
            <p className="text-sm opacity-80">Comprehensive insights and metrics</p>
          </div>
        </div>

        <div className="flex items-center gap-3">
          <button
            onClick={() => setAutoRefresh(!autoRefresh)}
            className={`px-4 py-2 rounded-lg border-2 border-gray-300 flex items-center gap-2 transition ${autoRefresh
              ? "bg-[var(--yellow)] text-[var(--black)]"
              : "bg-[var(--black)] text-[var(--yellow)]"
              }`}
          >
            <FiRefreshCw className={autoRefresh ? "animate-spin" : ""} />
            Auto Refresh
          </button>

          <button
            onClick={fetchAnalytics}
            className="px-4 py-2 rounded-lg border-2 border-gray-300 bg-[var(--black)] text-[var(--yellow)] flex items-center gap-2 hover:bg-[var(--yellow)] hover:text-[var(--black)] transition"
          >
            <FiRefreshCw />
            Refresh
          </button>

          <button
            onClick={() => {
              // Export functionality
              const dataStr = JSON.stringify(analytics, null, 2);
              const dataBlob = new Blob([dataStr], { type: "application/json" });
              const url = URL.createObjectURL(dataBlob);
              const link = document.createElement("a");
              link.href = url;
              link.download = `analytics-${new Date().toISOString().split("T")[0]}.json`;
              link.click();
            }}
            className="px-4 py-2 rounded-lg border-2 border-gray-300 bg-[var(--black)] text-[var(--yellow)] flex items-center gap-2 hover:bg-[var(--yellow)] hover:text-[var(--black)] transition"
          >
            <FiDownload />
            Export
          </button>
        </div>
      </div>

      {/* Filters */}
      <div className="flex flex-wrap items-center gap-4 p-4 bg-[var(--black)] border-2 border-gray-300 rounded-xl">
        <div className="flex items-center gap-2">
          <FiCalendar />
          <span className="font-medium">Time Range:</span>
          <select
            value={timeRange}
            onChange={(e) => setTimeRange(e.target.value)}
            className="bg-[var(--black)] border-2 border-gray-300 px-3 py-2 rounded text-[var(--yellow)]"
          >
            <option value="daily">Daily</option>
            <option value="weekly">Weekly</option>
            <option value="monthly">Monthly</option>
            <option value="yearly">Yearly</option>
          </select>
        </div>

        {timeRange === "daily" && (
          <div className="flex items-center gap-2">
            <span className="text-sm font-medium">Select Date:</span>
            <input
              type="date"
              value={selectedDate}
              onChange={(e) => setSelectedDate(e.target.value)}
              className="bg-[var(--black)] border-2 border-gray-300 px-3 py-2 rounded text-[var(--yellow)] focus:outline-none focus:ring-2 focus:ring-[color:var(--yellow)/0.6]"
            />
          </div>
        )}

        {timeRange === "weekly" && (
          <div className="flex flex-wrap items-center gap-4">
            <div className="flex items-center gap-2">
              <span className="text-sm font-medium text-[color:var(--yellow)/0.8]">From:</span>
              <input
                type="date"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
                className="bg-[var(--black)] border-2 border-gray-300 px-3 py-2 rounded text-[var(--yellow)] focus:outline-none focus:ring-2 focus:ring-[color:var(--yellow)/0.6]"
              />
            </div>
            <div className="flex items-center gap-2">
              <span className="text-sm font-medium text-[color:var(--yellow)/0.8]">To:</span>
              <input
                type="date"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
                className="bg-[var(--black)] border-2 border-gray-300 px-3 py-2 rounded text-[var(--yellow)] focus:outline-none focus:ring-2 focus:ring-[color:var(--yellow)/0.6]"
              />
            </div>
          </div>
        )}

        {timeRange === "yearly" && (
          <select
            value={year}
            onChange={(e) => setYear(Number(e.target.value))}
            className="bg-[var(--black)] border-2 border-gray-300 px-3 py-2 rounded text-[var(--yellow)]"
          >
            {[currentYear, currentYear - 1, currentYear - 2].map((y) => (
              <option key={y} value={y}>
                {y}
              </option>
            ))}
          </select>
        )}

        {timeRange === "monthly" && (
          <>
            <select
              value={year}
              onChange={(e) => setYear(Number(e.target.value))}
              className="bg-[var(--black)] border-2 border-gray-300 px-3 py-2 rounded text-[var(--yellow)]"
            >
              {[currentYear, currentYear - 1, currentYear - 2].map((y) => (
                <option key={y} value={y}>
                  {y}
                </option>
              ))}
            </select>
            <select
              value={month}
              onChange={(e) => setMonth(Number(e.target.value))}
              className="bg-[var(--black)] border-2 border-gray-300 px-3 py-2 rounded text-[var(--yellow)]"
            >
              {Array.from({ length: 12 }, (_, i) => i + 1).map((m) => (
                <option key={m} value={m}>
                  {new Date(year, m - 1).toLocaleString("en-US", { month: "long" })}
                </option>
              ))}
            </select>
          </>
        )}
      </div>

      {/* Tabs */}
      <div className="flex flex-wrap gap-2 border-b-2 border-gray-300">
        {[
          { id: "overview", label: "Overview", icon: <FiBarChart2 /> },
          { id: "users", label: "Users", icon: <FiUsers /> },
          { id: "revenue", label: "Revenue", icon: <FiDollarSign /> },
          { id: "calls", label: "Calls", icon: <FiPhone /> },
           { id: "violations", label: "violations", icon: <FiPhone /> }
        ].map((tab) => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            className={`px-6 py-3 font-medium flex items-center gap-2 transition ${activeTab === tab.id
              ? "border-b-4 border-gray-300 text-[var(--yellow)]"
              : "text-[color:var(--yellow)/0.6] hover:text-[var(--yellow)]"
              }`}
          >
            {tab.icon}
            {tab.label}
          </button>
        ))}
      </div>

      {/* Overview Tab */}
      {activeTab === "overview" && (
        <div className="space-y-6">
          {/* Key Metrics */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6">
            <MetricCard
              title="Total Users"
              value={formatNumber(analytics.totalUsers)}
              icon={<FiUsers />}

              color="yellow"
            />
            <MetricCard
              title="female Users"
              value={formatNumber(analytics.femaleUsers)}
              icon={<FiActivity />}
              color="green"
            />
            <MetricCard
              title="Total Revenue"
              value={formatCurrency(analytics.totalRevenue)}
              icon={<FiTrendingUp />}

              color="blue"
            />
            <MetricCard
              title="Total Withdrawals"
              value={formatCurrency(analytics.totalWithdrawn)}
              icon={<FiDownload />}
              color="purple"
            />
            <MetricCard
              title="Total Calls"
              value={formatNumber(analytics.totalCalls)}
              icon={<FiPhone />}
              color="orange"
            />
          </div>

          {/* Charts Row 1 */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            <ChartCard title="User Growth Trend">
              <UserGrowthChart data={analytics.userGrowth} year={year} />
            </ChartCard>

            <ChartCard title="Gender Distribution">
              <ResponsiveContainer width="100%" height={300}>
                <PieChart>
                  <Pie
                    data={genderData}
                    cx="50%"
                    cy="50%"
                    labelLine={false}
                    label={({ name, percent }) => `${name} ${(percent * 100).toFixed(0)}%`}
                    outerRadius={100}
                    fill="#8884d8"
                    dataKey="value"
                  >
                    {genderData.map((entry, index) => (
                      <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                    ))}
                  </Pie>
                  <Tooltip />
                </PieChart>
              </ResponsiveContainer>
            </ChartCard>
          </div>

          {/* Charts Row 2 */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            <ChartCard title="Revenue Trend">
              <ResponsiveContainer width="100%" height={300}>
                <AreaChart data={revenueData}>
                  <CartesianGrid strokeDasharray="3 3" stroke="rgba(255, 215, 0, 0.1)" />
                  <XAxis dataKey="month" stroke="var(--yellow)" />
                  <YAxis stroke="var(--yellow)" />
                  <Tooltip
                    contentStyle={{
                      backgroundColor: "var(--black)",
                      border: "2px solid var(--yellow)",
                      borderRadius: "8px",
                      color: "var(--yellow)",
                    }}
                  />
                  <Area
                    type="monotone"
                    dataKey="revenue"
                    stroke="var(--yellow)"
                    fill="var(--yellow)"
                    fillOpacity={0.3}
                  />
                </AreaChart>
              </ResponsiveContainer>
            </ChartCard>

            <ChartCard title="Call Statistics">
              <div className="space-y-4">
                <div className="flex justify-between items-center p-4 border border-gray-300 rounded-lg">
                  <span>Audio Calls</span>
                  <span className="text-2xl font-bold">{formatNumber(analytics.audioCalls)}</span>
                </div>
                <div className="flex justify-between items-center p-4 border border-gray-300 rounded-lg">
                  <span>Video Calls</span>
                  <span className="text-2xl font-bold">{formatNumber(analytics.videoCalls)}</span>
                </div>
                <div className="flex justify-between items-center p-4 border border-gray-300 rounded-lg">
                  <span>Total Calls</span>
                  <span className="text-2xl font-bold">{formatNumber(analytics.totalCalls)}</span>
                </div>
              </div>
            </ChartCard>
          </div>
        </div>
      )}

      {/* Users Tab */}
      {activeTab === "users" && (
        <div className="space-y-6">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <MetricCard
              title="total Users"
              value={formatNumber(analytics.total)}
              icon={<FiUsers />}
              color="blue"
            />
            <MetricCard
              title="New Users"
              value={formatNumber(analytics?.newUsers)}
              icon={<FiActivity />}
              color="green"
            />
            <MetricCard
              title="New Female Users"
              value={formatNumber(analytics?.newfemaleUsers || 0)}
              icon={<FiActivity />}
              color="purple"
            />
          </div>

          <ChartCard title="Monthly User Growth">
            <UserGrowthChart data={analytics.userGrowth} year={year} />
          </ChartCard>
        </div>
      )}

      {/* Revenue Tab */}
      {activeTab === "revenue" && (
        <div className="space-y-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            <MetricCard
              title="Total Revenue"
              value={formatCurrency(analytics.totalRevenue)}
              icon={<FiTrendingUp />}
              color="blue"
            />
            <MetricCard
              title="Total Withdrawals"
              value={formatCurrency(analytics.totalWithdrawn)}
              icon={<FiDownload />}
              color="purple"
            />
          </div>

          <ChartCard title="Revenue Trend">
            <ResponsiveContainer width="100%" height={400}>

              {revenueData.length === 0 ? (
                <div className="text-center py-10">No data</div>
              ) : (
                <BarChart key={`${timeRange}-${year}-${month}-${selectedDate}-${startDate}-${endDate}`} data={revenueData}>
                  <CartesianGrid strokeDasharray="3 3" stroke="rgba(255, 215, 0, 0.1)" />
                  <XAxis dataKey="month" stroke="var(--yellow)" />
                  <YAxis stroke="var(--yellow)" />
                  <Tooltip
                    contentStyle={{
                      backgroundColor: "var(--black)",
                      border: "2px solid var(--yellow)",
                      borderRadius: "8px",
                      color: "var(--yellow)",
                    }}
                    formatter={(value) => formatCurrency(value)}
                  />
                  <Bar dataKey="revenue" fill="var(--yellow)" radius={[8, 8, 0, 0]} />
                </BarChart>
              )}


            </ResponsiveContainer>
          </ChartCard>
        </div>
      )}







 {/* ✅ Violations Tab */}

      {activeTab === "violations" && (
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">

          {/* Violations Trend */}
          <ResponsiveContainer width="100%" height={350}>
            <BarChart data={analytics.violationsTrend}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="month" />
              <YAxis />
              <Tooltip />
              <Bar dataKey="reports" fill="#FF6B6B" />
            </BarChart>
          </ResponsiveContainer>

          {/* Block Trend */}
          <ResponsiveContainer width="100%" height={350}>
            <BarChart data={analytics.blockTrend}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="month" />
              <YAxis />
              <Tooltip />
              <Bar dataKey="blocks" fill="#4ECDC4" />
            </BarChart>
          </ResponsiveContainer>

        </div>
      )}







      {/* Calls Tab */}
      {activeTab === "calls" && (
        <div className="space-y-6">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <MetricCard
              title="Audio Calls"
              value={formatNumber(analytics.audioCalls)}
              icon={<FiPhone />}
              color="green"
            />
            <MetricCard
              title="Video Calls"
              value={formatNumber(analytics.videoCalls)}
              icon={<FiPhone />}
              color="blue"
            />
            <MetricCard
              title="Total Calls"
              value={formatNumber(analytics.totalCalls)}
              icon={<FiPhone />}
              color="purple"
            />
          </div>

          <ChartCard title="Call Type Distribution">
            <ResponsiveContainer width="100%" height={300}>
              <PieChart>
                <Pie
                  data={[
                    { name: "Audio", value: analytics.audioCalls },
                    { name: "Video", value: analytics.videoCalls },
                  ]}
                  cx="50%"
                  cy="50%"
                  labelLine={false}
                  label={({ name, percent }) => `${name} ${(percent * 100).toFixed(0)}%`}
                  outerRadius={100}
                  fill="#8884d8"
                  dataKey="value"
                >
                  <Cell fill="#FFD700" />
                  <Cell fill="#FFA500" />
                </Pie>
                <Tooltip />
              </PieChart>
            </ResponsiveContainer>
          </ChartCard>
        </div>
      )}
    </div>
  );
}

// Metric Card Component
function MetricCard({ title, value, icon, change, trend, size = "normal", color = "yellow" }) {
  const colorClasses = {
    yellow: {
      bg: "bg-gradient-to-br from-[var(--yellow)]/10 to-[var(--yellow)]/5 border-[var(--yellow)]/20",
      text: "text-[var(--yellow)]",
      icon: "text-[var(--yellow)]"
    },
    green: {
      bg: "bg-gradient-to-br from-green-500/10 to-green-500/5 border-green-500/20",
      text: "text-green-400",
      icon: "text-green-400"
    },
    blue: {
      bg: "bg-gradient-to-br from-blue-500/10 to-blue-500/5 border-blue-500/20",
      text: "text-blue-400",
      icon: "text-blue-400"
    },
    purple: {
      bg: "bg-gradient-to-br from-purple-500/10 to-purple-500/5 border-purple-500/20",
      text: "text-purple-400",
      icon: "text-purple-400"
    },
    orange: {
      bg: "bg-gradient-to-br from-orange-500/10 to-orange-500/5 border-orange-500/20",
      text: "text-orange-400",
      icon: "text-orange-400"
    }
  };

  return (
    <div className={`${colorClasses[color].bg} border-2 rounded-xl p-3 shadow-lg ${size === "large" ? "col-span-full" : ""
      }`}>
      <div className="flex items-center justify-between">
        <div className="flex-1">
          <div className={`text-xs font-medium ${colorClasses[color].text} mb-1 uppercase tracking-wider`}>
            {title}
          </div>
          <div className={`font-bold ${size === "large" ? "text-4xl" : "text-2xl"} ${colorClasses[color].text}`}>
            {value}
          </div>

          {change && (
            <div className={`flex items-center gap-1 mt-1 text-xs ${trend === "up" ? "text-green-400" : "text-red-400"
              }`}>
              {trend === "up" ? <FiArrowUp /> : <FiArrowDown />}
              {change}
            </div>
          )}
        </div>
        <div className={`text-3xl ${colorClasses[color].icon}`}>{icon}</div>
      </div>
    </div>
  );
}

// Chart Card Component
function ChartCard({ title, children }) {
  return (
    <div className="rounded-lg p-6 border-2 border-gray-300 bg-[var(--black)] shadow-sm">
      <h3 className="text-xl font-bold mb-4">{title}</h3>
      {children}
    </div>
  );
}

// User Growth Chart Component
function UserGrowthChart({ data, year }) {
  const maxGrowth = data.length > 0 ? Math.max(...data.map((i) => i.count || 0)) : 1;

  if (!data || data.length === 0) {
    return (
      <div className="h-64 flex items-center justify-center text-[color:var(--yellow)/0.8] border-2 border-dashed border-[color:var(--yellow)/0.06] rounded">
        No growth data available
      </div>
    );
  }

  return (
    <ResponsiveContainer width="100%" height={300}>
      <BarChart data={data.map((item) => ({
        month:
  typeof item.month === "number"
    ? new Date(year, item.month - 1)
        .toLocaleString("en-US",{month:"short"})
    : item.month,

        count: item.count || 0,
      }))}>
        <CartesianGrid strokeDasharray="3 3" stroke="rgba(255, 215, 0, 0.1)" />
        <XAxis dataKey="month" stroke="var(--yellow)" />
        <YAxis stroke="var(--yellow)" />
        <Tooltip
          contentStyle={{
            backgroundColor: "var(--black)",
            border: "2px solid var(--yellow)",
            borderRadius: "8px",
            color: "var(--yellow)",
          }}
        />
        <Bar dataKey="count" fill="var(--yellow)" radius={[8, 8, 0, 0]} />
      </BarChart>
    </ResponsiveContainer>
  );
}
